export interface BonusEntitlement {
    from: Date;
    content: string;
    type: BonusEntitlementType;
}

export enum BonusEntitlementType {
    UNKNOWN = "UNKNOWN",
    STORY = "STORY",
    LIBRARY = "LIBRARY",
    ACTIVITY = "ACTIVITY"
}